import { SiteRecceStatusEnum } from '@api/enum';
import { getSiteRecceByStatus } from '@api/services/site-recce.service';
import useDataQuery from '@hooks/use-data-query';

export const useSiteRecceByStatusListData = (status: SiteRecceStatusEnum) => {
    const siteRecceListQuery = useDataQuery(['all-site-recces', status], () => getSiteRecceByStatus(status));

    const sortedList = siteRecceListQuery.data?.slice().sort((a, b) => {
        const aDate = a.assignedDate ? parseInt(a.assignedDate) : null;
        const bDate = b.assignedDate ? parseInt(b.assignedDate) : null;

        if (aDate && bDate) return aDate - bDate; // ✅ ascending order
        if (aDate && !bDate) return -1; // a has date, b doesn't → a first
        if (!aDate && bDate) return 1; // b has date, a doesn't → b first
        return 0; // both missing → keep original order
    });

    return {
        siteRecceList: sortedList,
        isLoading: siteRecceListQuery.isLoading,
    };
};
